import { SimpleGrid, Text } from '@chakra-ui/react';

import CustomFieldBuilder from 'components/CustomFieldBuilder';
import { ICustomFieldItem } from 'hooks/customField/useFetchPaginatedCustomFields';

const JobCustomFields = ({ customFieldsData }: { customFieldsData: Array<ICustomFieldItem> }) => {
  return (
    <>
      {Array.isArray(customFieldsData) ? (
        customFieldsData.length ? (
          <SimpleGrid columns={2} spacing="4">
            {customFieldsData.map(customField => {
              return (
                <div key={customField.id}>
                  <CustomFieldBuilder customField={customField as ICustomFieldItem} />
                </div>
              );
            })}{' '}
          </SimpleGrid>
        ) : (
          <Text mb="4" p="4">
            No custom fields available. Please add or unarchive custom fields to use them in the form.
          </Text>
        )
      ) : null}
    </>
  );
};

export default JobCustomFields;
